<template>
  <div>
    <v-btn icon @click="editDialog = true">
      <v-img max-width="20" max-height="20" src="/img/icons/pencil.svg"></v-img>
    </v-btn>

    <v-dialog v-model="editDialog" max-width="700px">
      <v-card>
        <v-card-title class="headline">ویرایش شرکت</v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.name"
                label="نام شرکت"
                outlined
                dense
                disabled
              />
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.current_package"
                :items="packages"
                item-value="name"
                item-text="name_display"
                label="پکیج جاری"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <date label="تاریخ شروع" v-model="form.start_at" :default="false" :clearable="true" type="date" />

            </v-col>

            <v-col cols="12" md="6">
              <date label="تاریخ پایان" v-model="form.expire_at" :disabled="disabledDate" :default="false" :clearable="true" type="date" />
            </v-col>

            <v-col cols="12" md="12">              
              <v-switch label="آزمایشی" v-model="form.is_trial" />
            </v-col>

          </v-row>
        
          <v-divider class="my-4"></v-divider>
          <h4 class="subtitle-1 font-weight-bold mb-2">افزونه‌ها</h4>

          <v-row v-for="(ext, key) in extensionsArray" :key="key">
            <v-col cols="12" md="3">
              <v-select
                v-model="ext.name"
                :items="extensions"
                item-value="name"
                item-text="name_display"
                label="نام افزونه"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="3">
                  <date label="تاریخ شروع" v-model="ext.start_at" :default="false" :clearable="true" type="date" />
            </v-col>

            <v-col cols="12" md="3">

                <date label="تاریخ پایان" v-model="ext.expire_at" :default="false" :clearable="true" type="date" />
            </v-col>
            <v-col cols="12" md="2">
              <v-switch label="آزمایشی" v-model="ext.is_trial" />
            </v-col>

            <v-col cols="12" md="1">
              <v-btn icon color="red" @click="removeExtension(key)">
                <v-img class="ml-1" max-width="30" src="/img/icons/delete.svg"></v-img>
              </v-btn>
            </v-col>
          </v-row>
          <v-btn color="primary" class="my-2" :disabled="extensionsArray.length >1" @click="addExtension">افزودن افزونه</v-btn>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">انصراف</v-btn>
          <v-btn color="primary" @click="save">ذخیره</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'EditCompany',
  props: {
    item: Object,
  },
  data() {
    return {
      editDialog: false,
      extensions: [
        {
          name: 'PAYROLL',
          name_display: "حقوق و دستمزد",
        },
        {
          name: 'MIZBAN',
          name_display: "میزبان",
        }
      ],
      packages: [
        {
          name: 'ONE',
          name_display: 'رایگان'
        },
        {
          name: 'TWO',
          name_display: 'پایه'
        },
        {
          name: 'THREE',
          name_display: 'هوشمند'
        },
        {
          name: 'FOUR',
          name_display: 'قدرتمند'
        },
      ],
      form: {
        name: '',
        current_package: {},
        start_at: '',
        expire_at: '',
        is_trial: false,
      },
      extensionsArray: [],
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form.name = newVal.name || '';
          this.form.current_package = newVal.current_package?.name || '';
          this.form.start_at = newVal.current_package?.start_at || '';
          this.form.expire_at = newVal.current_package?.expire_at || '';
          this.form.is_trial = newVal.current_package?.is_trial || false;

          this.extensionsArray = Object.values(newVal.current_extensions || {})
            .filter(ext => ext.name !== newVal.current_package?.name)
            .map(ext => ({
              ...ext,
            }));
        }
      },
    },
  },
  computed: {
    disabledDate() {
      return this.form.current_package === "ONE";
    }
  },
  methods: {
    addExtension() {
      this.extensionsArray.push({
        name: '',
        name_display: '',
        start_at: '',
        expire_at: '',
        is_trial: false,
      });
    },
    removeExtension(index) {
      this.extensionsArray.splice(index, 1);
    },
    save() {
      this.extensionsArray.push({
        name: this.form.current_package,
        start_at: this.form.start_at,
        expire_at: this.form.expire_at,
        is_trial: this.form.is_trial,
      });
      const payload = {
        extensions: this.extensionsArray.map(ext => ({
          name: ext.name,
          start_at: this.toGDate(ext.start_at),
          expire_at: this.toGDate(ext.expire_at),
          is_trial: ext.is_trial
        })),
      };

      this.request({
        url: this.endpoint(`sobhanAdmin/companies/${this.item.id}/`),
        method: "patch",
        data: payload,
        success: data => {
          this.successNotify();
          this.editDialog = false;
          window.location.reload();
        }
      });
    },
  },
};
</script>
